document.querySelectorAll<HTMLInputElement>('input.js-spam-protection').forEach(($el) => {
  setInterval(() => {
    if (Number.isNaN(parseInt($el.value, 10)) === true) {
      $el.value = '0';
    } else {
      $el.value = (parseInt($el.value, 10) + 17).toString();
    }
  }, 1000);
});
